import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useSubmitLineup = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(
    async ({
      userId,
      eventId,
      eventName,
      selections,
      alternates,
      leagueId,
      projectedTotal,
      alternateLotn,
    }) => {
      const token = await getAccessTokenSilently();
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(
        `${apiUrl}/api/lineup/submit-lineup`,
        {
          userId,
          eventId,
          eventName,
          selections,
          alternates,
          leagueId,
          projectedTotal,
          alternateLotn,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        // toast.success("Lineup submitted successfully!");
        // The variables argument contains the variables passed to the mutation
        // Now you can access userId and eventId directly from variables
        queryClient.invalidateQueries(["lineupSubmissions", variables.userId]);
        queryClient.invalidateQueries(["eventDetails", variables.eventId]);
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred submitting lineup.";
        toast.error(errorMessage);
        console.error(
          "Error submitting lineup:",
          error.response?.data?.message || "An error occurred.",
        );
      },
    },
  );
};
